import { Grid, Tabs, Tab, Box } from "@mui/material";
import React, { useState } from "react";
import EpaymentTransactionsHeader from "./home/header";
import EpaymentTransactionsTable from "./home/table";
import PosEPaymentsTable from "../../reports/posEPayments/home/table";
import { MdAttachMoney, MdPayment } from "react-icons/md";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const EpaymentTransactions = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="payment tabs"
            variant="fullWidth"
          >
            <Tab
              icon={<MdAttachMoney />}
              label="المعاملات المالية"
              id="tab-0"
              aria-controls="simple-tabpanel-0"
            />
            <Tab
              icon={<MdPayment />}
              label="المعاملات المالية حسب النقطة"
              id="tab-1"
              aria-controls="simple-tabpanel-1"
            />
          </Tabs>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <TabPanel value={tabValue} index={0}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <EpaymentTransactionsHeader />
            </Grid>
            <Grid item xs={12}>
              <EpaymentTransactionsTable />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <PosEPaymentsTable isFetchData={true} />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

export default EpaymentTransactions;
